// One cumulative payload per 30 seconds, plus play/pause/end/page exit.
// No viewer events are written directly to SQL by the player.
export function createPlaybackTracker(player, video, send, env = {}) {
  const clock = env.clock || (() => Date.now());
  const identity = env.identity || (() => {
    try { return window.crypto.randomUUID().replace(/-/g, ''); }
    catch (e) { return `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`; }
  });
  let visitor;
  try {
    visitor = window.localStorage.getItem('gv.analytics.visitor');
    if (!visitor || !/^[a-zA-Z0-9_-]{16,80}$/.test(visitor)) {
      visitor = identity();
      window.localStorage.setItem('gv.analytics.visitor', visitor);
    }
  } catch (e) { visitor = identity(); }
  const session = identity();
  let sequence = 0;
  let watched = 0;
  let played = false;
  let finished = false;
  let active = false;
  let lastTime = Number(player.currentTime()) || 0;
  let lastClock = clock();
  let lastSent = -1;
  const handlers = [];
  const sample = () => {
    const now = clock();
    const position = Number(player.currentTime()) || 0;
    const elapsed = Math.max(0, (now - lastClock) / 1000);
    const delta = position - lastTime;
    const rate = Number(player.playbackRate && player.playbackRate()) || 1;
    if (active && !player.seeking() && delta > 0 && delta <= elapsed * rate + 1) watched += Math.min(elapsed, delta / rate, 5);
    lastTime = position;
    lastClock = now;
  };
  const flush = (exit = false) => {
    sample();
    const stamp = `${played}:${finished}:${Math.floor(watched)}`;
    if (stamp === lastSent) return;
    lastSent = stamp;
    send({ video_id: Number(video.id), permalink: video.permalinks, visitor, session,
      sequence: sequence++, watched: Math.floor(watched), played, finished }, exit);
  };
  const on = (name, fn) => { player.on(name, fn); handlers.push([name, fn]); };
  on('playing', () => { sample(); active = true; if (!played) { played = true; flush(); } });
  on('timeupdate', sample);
  on('seeking', () => { active = false; sample(); });
  on('seeked', () => { sample(); active = !player.paused(); });
  on('waiting', () => { sample(); active = false; });
  on('pause', () => { sample(); active = false; flush(); });
  on('ended', () => { sample(); active = false; finished = played; flush(); });
  flush();
  return {
    flush,
    destroy() { flush(true); handlers.forEach(([name, fn]) => player.off(name, fn)); },
  };
}
